import BrowserSupport from './BrowserSupport';
export default BrowserSupport;



// WEBPACK FOOTER //
// ./src/components/BrowserSupport/index.js